import { Outlet, NavLink } from "react-router";
import {
  LayoutDashboard,
  Tag,
  Router as RouterIcon,
  Receipt,
  Settings,
  LogOut,
} from "lucide-react";
import { useAuth } from "../lib/auth.tsx";

const navItems = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/packages", label: "Packages", icon: Tag, end: false },
  { to: "/routers", label: "Routers", icon: RouterIcon, end: false },
  { to: "/vouchers", label: "Vouchers", icon: Receipt, end: false },
  { to: "/settings", label: "Settings", icon: Settings, end: false },
];

export function Layout() {
  const { tenant, signOut } = useAuth();
  return (
    <div className="flex min-h-screen bg-slate-50">
      <aside className="hidden w-60 shrink-0 flex-col border-r border-slate-200 bg-white md:flex">
        <div className="flex h-16 items-center gap-2 border-b border-slate-200 px-6 font-semibold">
          <span className="grid h-7 w-7 place-items-center rounded-md bg-brand-500 text-white">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="h-3.5 w-3.5"
            >
              <path d="M6 14l4-4 4 4 4-6 4 4" />
            </svg>
          </span>
          <span className="tracking-tight">SpotMesh</span>
        </div>
        <nav className="flex-1 space-y-1 px-3 py-4 text-sm">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-3 rounded-md px-3 py-2 transition-colors ${
                  isActive
                    ? "bg-brand-50 text-brand-700"
                    : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                }`
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="border-t border-slate-200 p-3 text-sm">
          <div className="px-3 pb-2">
            <p className="truncate font-medium text-slate-900">
              {tenant?.name ?? "—"}
            </p>
            <p className="truncate text-xs text-slate-500">
              {tenant?.email ?? ""}
            </p>
          </div>
          <button
            type="button"
            onClick={signOut}
            className="flex w-full items-center gap-3 rounded-md px-3 py-2 text-slate-600 hover:bg-slate-100 hover:text-slate-900"
          >
            <LogOut className="h-4 w-4" />
            Sign out
          </button>
        </div>
      </aside>
      <main className="flex flex-1 flex-col">
        <header className="flex h-16 items-center gap-4 border-b border-slate-200 bg-white px-6">
          <h1 className="text-base font-semibold text-slate-900">
            Vendor admin
          </h1>
          <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-500">
            placeholder auth
          </span>
        </header>
        <div className="flex-1 p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
